/* Shopify Forms owns validation and submission. Enhance contact-page styling
   and keep its success confirmation visible after the form collapses. */
(() => {
  if (window.giestoContactFormStyles) return;
  window.giestoContactFormStyles = true;
  const selector = '[data-giesto-contact-form-styles]';
  const observed = new WeakSet();

  function mount(container) {
    const stylesheet = container.dataset.giestoContactFormStyles;
    if (!stylesheet) return;
    const successObservers = [];
    const apply = () => {
      container.querySelectorAll('shopify-forms-embed').forEach((host) => {
        const root = host.shadowRoot;
        if (!root || root.querySelector('[data-giesto-contact-styles]')) return;
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = stylesheet;
        link.dataset.giestoContactStyles = '';
        root.append(link);

        let successShown = Boolean(root.querySelector('[data-current-step="success"]'));
        const successObserver = new MutationObserver(() => {
          const success = root.querySelector('[data-current-step="success"]');
          if (!success) { successShown = false; return; }
          if (successShown) return;
          successShown = true;
          // Run after Shopify replaces the fields and starts its own smooth
          // scroll. An instant scroll cancels that now-stale destination.
          requestAnimationFrame(() => {
            if (!container.isConnected || !success.isConnected) return;
            success.setAttribute('tabindex', '-1');
            success.focus({ preventScroll: true });
            const top = container.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({ top: Math.max(0, top - 160), behavior: 'instant' });
          });
        });
        successObserver.observe(root, {
          childList: true, subtree: true, attributes: true,
          attributeFilter: ['data-current-step'],
        });
        successObservers.push(successObserver);
      });
    };
    apply();
    if (observed.has(container)) return;
    observed.add(container);
    const observer = new MutationObserver(apply);
    observer.observe(container, { childList: true, subtree: true });
    customElements.whenDefined('shopify-forms-embed').then(apply);
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(container)) {
        observer.disconnect();
        successObservers.forEach((item) => item.disconnect());
      }
    });
  }

  function init() { document.querySelectorAll(selector).forEach(mount); }
  init();
  document.addEventListener('shopify:section:load', init);
})();
